export default __webpack_public_path__ + "static/DMSans-BoldItalic-1e3032cd43176983ee05a4724d341c29.woff2";